// extracted by mini-css-extract-plugin
export var filterIncDec = "_3r-0";
export var leftBorder = "_3r-1";
export var rightBorder = "_3r-2";
export var stringInput = "_3r-3";